var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('q-badge',{attrs:{"label":_vm.getBadgeValue(_vm.value).label,"color":_vm.getBadgeValue(_vm.value).color}}),_c('q-tooltip',[_vm._v(" "+_vm._s(_vm.value)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }